module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#bundle",
      toString: function () {
        return this.url;
      }
    }